import { createContext } from "react";

export const PlanDataContext = createContext(null);
export const PlanDispatchContext = createContext(null);
